import React from 'react';
import { Navigate, useLocation } from "react-router-dom";
import AccessDenied from '../Login/AccessDenied';
import { isUserAuthenticated, isUserInRoles } from './UserIdentity';

//Protect client route by checking user roles
const RouteGuard = (props) => {
    const { roles, children, context } = props;
    const rlocation = useLocation();
    const path = rlocation.pathname + rlocation.search + rlocation.hash;

    if (!isUserAuthenticated(context)) {
        return <Navigate to='/Login' replace={true} state={{ from: path }} />
    }

    if (!isUserInRoles(roles, context)) {
        return <AccessDenied path={path} />
    }

    return children;
}

export default RouteGuard;